import { useIsomorphicLayoutEffect } from 'react-use';
import { create } from 'zustand';
import {
  persist,
  createJSONStorage,
  subscribeWithSelector,
} from 'zustand/middleware';
import { useFn } from './useFn';

export type IGlobalState = {
  // 登录用户信息
  info: {
    GUID?: string;
    Name?: string;
    Mobile?: string;
    Avatar?: string;
    Phone?: string;
    IDCard?: {
      Type: number | null;
      Name?: string;
      Number?: string;
    };
    Department?: string;
    Position?: string;
  };
  // 是否实名
  real_status: boolean;
  // 用户展示的字段
  userName: string;
  // 是否登录
  is_login: boolean;
  // 身份信息 teamType: 个人 1 团队 2
  currentIdentity: { teamId?: string; teamType?: number };
  // 是否有团队
  hasTeam: boolean;
};

const initialState: IGlobalState = {
  hasTeam: false,
  info: {},
  currentIdentity: {},
  real_status: false,
  is_login: false,
  userName: '',
};

export const useGlobal = create(
  subscribeWithSelector(
    persist<IGlobalState>(
      (set, get) => ({
        ...initialState,
        clear() {
          set(initialState);
        },
      }),
      {
        name: 'open.ssv.qq.com',
        version: 1,
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);

export const useHydrationCallback = (
  callback: (state: IGlobalState) => void,
  deps: any[] = []
) => {
  const fn = useFn(callback);

  useIsomorphicLayoutEffect(() => {
    useGlobal.persist.onFinishHydration(() => {
      console.log('hydrated');
      fn?.(useGlobal.getState());
    });
  }, deps);
};
